module.exports = __webpack_public_path__ + "static/media/素麻油雞線面.73aef33f.jpg";